<div class="spinner-wrapper" *ngIf="showSpinner">
    <loading-spinner></loading-spinner>
</div>
<router-outlet></router-outlet>
